import React, { Component } from "react";
import TabbedInstructionHeader from "./TabbedInstructionHeader";

export default class LiteracyInstruction extends Component {
    constructor(props) {
        super(props);
        this.circleClick = this.circleClick.bind(this);
        this.optionChange = this.optionChange.bind(this);
    }

    circleClick(tabId) {
        if (!this.props.waitingForSpeech) {
            this.props.setCurrentTab(tabId);
        }
    }

    optionChange(value) {
        this.props.clearDisableNext();
    }

    render() {
        const p = this.props;

        return (
<div className="test-page-content-inner test-page-instruction test-page-literacy-instruction" >
    <TabbedInstructionHeader currentTabId={p.currentTabId} elems={p.content.elems[0].elems} circleClick={this.circleClick} />
    <div className="practice-content">
        {renderPractice(p, this.optionChange)}
    </div>
</div>
        );
    }
}

function renderPractice(props, optionChange) {
    return (
        <div className="practice-content-inner">
            <div className="passage">
                {renderItems(props.content.passage)}
            </div>
            <hr/>
            <h2 className="question-title">Question</h2>
            <div className="question">
                {props.content.question}
            </div>
            <h2 className="answer-title">Answer</h2>
            <div className="options">
                {renderOptions(props.content.options, props, optionChange)}
            </div>
        </div>
    );
}

function renderItems(elems) {
    return elems.map(function (elem, index) {
        return renderItem(elem, index);
    });
}

function renderItem(elem, index) {
    switch (elem.type) {
    case "h1":
        return <h1 key={index}>{elem.text}</h1>;
    case "h2":
        return <h2 key={index}>{elem.text}</h2>;
    case "p":
        return <p key={index}>{elem.text}</p>;
    default:
        return null;
    }
}

function renderOptions(elems, props, optionChange) {
    return elems.map(function (elem, index) {
        return renderOption(elem, props, index + 1, optionChange);
    });
}

function renderOption(elem, props, optionValue, optionChange) {
    const disabled = props.waitingForSpeech ? 'disabled' : '';
    const id = `option${optionValue}`;

    return (
<div className="inputGroup" key={optionValue}>
    <input id={id} type="radio" name="option" value={optionValue} onClick={() => optionChange(optionValue)} disabled={disabled} />
    <label htmlFor={id}><span><span /></span></label>
    <span className="option-text">{elem.text}</span>
</div>
    );
}
